// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-link{\n    text-decoration: none;\n}\n   \n.info-cell {\n    display: flex;\n    align-items: center;\n}\n\n.info-cell-left {\n\n}\n\n.info-cell-right {\n}\n\n.info-cell-title {\n    font-size: 12px;\n    color:rgb(161, 159, 157);\n}\n\n.info-cell-value {\n    font-size: 14px\n}", ""]);
// Exports
module.exports = exports;
